// extracted by mini-css-extract-plugin
export var barContainer = "_61-0";
export var extraThin = "_61-3";
export var fillBar = "_61-6";
export var fillContainer = "_61-4";
export var overflow = "_61-8";
export var overflowContainer = "_61-5";
export var regular = "_61-7";
export var thick = "_61-1";
export var thin = "_61-2";